<fuse-loading-bar></fuse-loading-bar>

<fuse-vertical-navigation
    class="dark print:hidden"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="sidebarNavigation"
    [opened]="!isScreenSmall">

    <!-- Header: Logo + OfficeMaps / Admin Center -->
    <ng-container fuseVerticalNavigationHeader>
        <div class="classy-sidebar-header">
            <img class="classy-logo" src="assets/images/logo/OfficeMapsLogo-NoText.png" alt="OfficeMaps" />
            <div class="classy-branding">
                <span class="classy-brand-title">OfficeMaps</span>
                <span class="classy-brand-subtitle">Admin Center</span>
            </div>
        </div>
    </ng-container>

    <!-- Content header: User card -->
    <ng-container fuseVerticalNavigationContentHeader>
        <div class="classy-user-card">
            <div class="classy-user-avatar">
                <mat-icon svgIcon="heroicons_outline:user-circle"></mat-icon>
            </div>
            <div class="classy-user-info">
                <div class="classy-user-name">{{ user?.name || 'Admin User' }}</div>
                <div class="classy-user-email overflow-hidden text-ellipsis" [title]="user?.email || 'admin@company.com'">{{ user?.email || 'admin@company.com' }}</div>
            </div>
        </div>
    </ng-container>

    <!-- Navigation items rendered by Fuse (no extra content) -->

    <!-- Footer: Sign Out + Version -->
    <ng-container fuseVerticalNavigationFooter>
        <div class="classy-sidebar-footer">
            <a mat-button class="classy-sign-out-btn rounded-lg" [routerLink]="['/sign-out']">
                <mat-icon svgIcon="heroicons_outline:logout"></mat-icon>
                Sign Out
            </a>
            <div class="classy-version text-center">Version {{ version }}</div>
        </div>
    </ng-container>
</fuse-vertical-navigation>

<div class="flex flex-col flex-auto w-full min-w-0">
    <div class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
        <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
        </button>
        <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
        </div>
    </div>
    <div class="flex flex-col flex-auto">
        <router-outlet *ngIf="true"></router-outlet>
    </div>
</div>
